const appConfig = {
  awsAccountId: "167727748036",
  awsRegion: "us-east-1",
  awsPartition: "aws",
  awsUrlSuffix: "amazonaws.com",
  consoleHostname: "console.aws.amazon.com",
};

export default appConfig;
